<template>
  <v-col cols="12">
    <v-form @submit.prevent="save" lazy-validation v-model="valid" ref="form">
      <v-card tile flat outlined class="mx-1">
        <v-card-title>
          <p> {{ titulo }} : {{ permissao }} </p>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-textarea
                v-model="formularioEditor.totalMulheres"
                label="Número de Mulheres"
                rows="1"
                filled
                auto-grow
                :rules="[(v) => !!v || 'Número de Mulheres é obrigatório.']"
              ></v-textarea>
            </v-col>
            <v-col cols="4">
              <v-textarea
                v-model="formularioEditor.totalHomens"
                label="Número de Homens"
                rows="1"
                :rules="[(v) => !!v || 'Número de Homens é obrigatório.']"
                auto-grow
                filled
              ></v-textarea>
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="formularioEditor.tipoEncontro"
                :items="['PRESENCIAL', 'VIRTUAL']"
                label="Tipo Presença"
                :rules="[(v) => !!v || 'Tipo da Presença é obrigatória.']"
                filled
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="permissao" class="mx-1 ml-2 mt-n4">
          <v-btn :loading="isFetching" type="submit" color="success text-center" small>{{ isUpdate ? "Salvar alterações" : "Criar" }}</v-btn>
          <v-btn @click.prevent="cancel" color="error text-center" small>Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-col>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    formulario: {
      type: Object,
      required: false,
    },
    lancamento: {
      type: Object,
      required: false,
    },
    permissao: {
      required: false,
    }

  },

  data() {
    return {
      formularioEditor: this.formulario ? Object.assign({}, this.formulario) : this.formularioEditorReset(),
      valid: true,
      requiredRule: [(v) => !!v || "Campo obrigatório"],
      errorMessage: ""

    };
  },
  computed: {
    ...mapState('formulario', {
      isFetching: state => state.isFetching,
    }),   

    isUpdate() {
      return !!this.formulario;
    },
    titulo() {
      return this.isUpdate ? "Editar Lista de Presença" : "Nova Lista de Presença" 
    },

  },
  methods: {
    ...mapActions('formulario', ['criarListaPresenca']),
    ...mapActions('formulario', ['editarListaPresenca']),

    save() {
      if(this.$refs.form.validate()) {
        this.persist().then((formulario) => {
          this.$refs.form.resetValidation()
          this.formularioEditor = this.formularioEditorReset();
          this.$emit("save", { formulario });
        })
         .catch((error) => {
           if (error.response) {
             this.errorMessage = error.response.data
           }
         })
      }
    },
    persist() {
      return this.isUpdate ? this.update() : this.create();
    },
    create() {
      const payload = {
        "indicadorId": this.lancamento.indicador.id,
        "lancamentoId": this.lancamento.id,
        "formulario": this.formularioEditor
      }

      return this.criarListaPresenca(payload)
    },
    update() {
      this.formularioEditor.lancamentoFonte = {}
      const payload = {
        "indicadorId": this.formulario.lancamentoFonte.indicador.id, 
        "lancamentoId": this.formulario.lancamentoFonte.id, 
        "formularioId": this.formulario.id, 
        "formulario": this.formularioEditor
      }      
      return this.editarListaPresenca(payload);
    },
    cancel() {
      this.$refs.form.reset();
      this.$emit("cancel");
    },
    formularioEditorReset() {
      return {};
    },
  },
};
</script>

<style scoped>
</style>
